(function () {
    "use strict";

    // @ngInject
    function CompanySettingsGalleryControllerCtor($scope, CompaniesManager, _, ModalService, $injector) {

        var self = this;
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsGalleryController';
        this._ = _;

        this.CompaniesManager = CompaniesManager;
        this.company = this.CompaniesManager.getCurrCompany();
        if (this.company.cover_images === undefined) {
            this.company.cover_images = [];
        }

        if (this.company.company_assets === undefined) {
            this.company.company_assets = [];
        }

        this.formattedCompanyAssets = [];

        var unwatchCompanyAssets = $scope.$watchCollection('companySettingsGalleryVm.company.company_assets', function (newCompanyAssets) {
            if (newCompanyAssets) {
                self.formattedCompanyAssets = newCompanyAssets.map(function (file) {
                    return {
                        _id: file._id,
                        name: file.asset_name,
                        type: file.file_type,
                        url: file.url
                    };
                });
            }
        });

        $scope.$on('$destroy', function () {
            unwatchCompanyAssets();
        });

        this.companyAssetsUpdateCallbackForReact = this.companyAssetsUpdateCallback.bind(this);
        this.onImageDeletedCallbackForReact = this.onImageDeletedCallback.bind(this);
        this.onFileDeletedCallbackForReact = this.onFileDeletedCallback.bind(this);
        this.onSetAsDefaultCallbackForReact = this.onSetAsDefaultCallback.bind(this);
    }


    Controllers.CompanySettingsGalleryController = Class(Controllers.BaseController, {

        constructor: CompanySettingsGalleryControllerCtor,

        analyticsProperties: function analyticsProperties() {
            return {
                companyId: this.company._id
            };
        },

        companyAssetsUpdateCallback: function companyAssetsUpdateCallback(images, files) {
            this.company.cover_images = images;
            this.company.company_assets = files;
        },

        onImageDeletedCallback: function onImageDeletedCallback(imageId) {
            this.company.cover_images = this.company.cover_images.filter(function (image) {
                return image._id !== imageId;
            });
        },

        onFileDeletedCallback: function onFileDeletedCallback(fileId) {
            this.company.company_assets = this.company.company_assets.filter(function (file) {
                return file._id !== fileId;
            });
        },

        onSetAsDefaultCallback: function onSetAsDefaultCallback(imageId) {
            this.company.default_cover_image_id = imageId;
        }
    });
}());
